/**
 * Just an empty function
 */
const noop = () => {}

export default noop
